const darkTheme = {};

darkTheme.palette = {
  primary: [
    "#5850ec", // 0: primary color
  ],
  bgColor: ["#282d33"],
  surfaceColor: ["#000000"],
  border: [
    "#434343", // 0: Border
  ],
  iconBg: [
    "#000000", //0: icons background
  ],
  textColor: [
    "rgba(255, 255, 255, 0.85)", //0: text color
  ],
  focusColor: [
    "#177ddc", //0: focus color
  ],
};

darkTheme.fonts = {
  primary: "Open Sans, sans-serif, Roboto",
  pre: "Consolas, Liberation Mono, Menlo, Courier, monospace",
};
darkTheme.name = "darkTheme";

export default darkTheme;
